import { AlertTriangle } from "lucide-react";

export default function DemoBanner() {
  return (
    <div className="flex flex-col gap-2.5 rounded-lg border border-amber-200 bg-warning-bg px-4 py-3">
      <div className="flex items-start gap-2.5">
        <AlertTriangle className="mt-0.5 h-4 w-4 shrink-0 text-warning" />
        <p className="text-[13px] leading-snug text-ink">
          DEMO SIMULATION — This is a test page for internal use. It is not a real bank
          authorisation page and collects no real credentials.
        </p>
      </div>
      <p className="pl-6.5 text-xs text-[#94A3B8]">In production this page is hosted by the payment provider.</p>
    </div>
  );
}